let host = 'https://fountain-scientific.com'
module.exports = {
    url:{
        login:`${host}/login`,
        newGoods:`${host}/newGoods`,
        register:`${host}/createUser`,
        searchByName:`${host}/searchByName`,
        getSingleInfo:`${host}//getSingleInfo`,
        classify:`${host}/classify`,
        notices:`${host}/notices`,
        apply:`${host}/apply`,
        catalogApply:`${host}/catalogApply`,
        skill:`${host}/tech`,
        topTech:`${host}/tech`,
        web:`${host}/web`,
        newApp:`${host}/newApp`,
        food:`${host}/food`,
        goodTable:`${host}/goodTable`,
        employments:`${host}/employments`,
        imfor: `${host}/v2/fly`,
        contact: `${host}/v2/contact`
    }
};


// WEBPACK FOOTER //
// ./src/url.js